
export enum SeriesFilterTypesEnum {
    keywords = 'keywords',
    authors = 'authors',
    outlets = 'outlets',
    audience = 'audience',
    ave = 'ave',
    sentiment = 'sentiment',
    mediaTypes = 'mediaTypes', // must match monitoring-filters.enum
    country = 'country',
    province = 'province',
    regions = 'regions',
    languages = 'languages',
    duplicates = 'duplicates',
    tags = 'tags',
    tagGroups = 'tagGroups',
    sourceGroups = 'sourceGroups',
    agents = 'agents',
    /** Curation agents, unlike the social agents above */
    aiAgents = 'aiAgents',
    engagement = 'engagement',
    engagementRate = 'engagementRate',
    hashtags = 'hashtags',
    prominence = 'prominence',
    discoverLists = 'discoverLists',
    domainAuthority = 'domainAuthority'
}


export const socialSeriesFilterTypes = [
    SeriesFilterTypesEnum.keywords,
    SeriesFilterTypesEnum.authors,
    SeriesFilterTypesEnum.outlets,
    SeriesFilterTypesEnum.audience,
    SeriesFilterTypesEnum.ave,
    SeriesFilterTypesEnum.sentiment,
    SeriesFilterTypesEnum.mediaTypes,
    SeriesFilterTypesEnum.country,
    SeriesFilterTypesEnum.province,
    SeriesFilterTypesEnum.regions,
    SeriesFilterTypesEnum.languages,
    SeriesFilterTypesEnum.duplicates,
    SeriesFilterTypesEnum.aiAgents,
    SeriesFilterTypesEnum.tags,
    SeriesFilterTypesEnum.tagGroups,
    SeriesFilterTypesEnum.sourceGroups,
    SeriesFilterTypesEnum.agents,
    SeriesFilterTypesEnum.engagement,
    SeriesFilterTypesEnum.engagementRate,
    SeriesFilterTypesEnum.hashtags,
    SeriesFilterTypesEnum.discoverLists
];
